import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import fileTemplates from 'actions/fileTemplates'
import filterTemplates from 'actions/filterTemplates'
import { createDownloadItemsDispatchToProps } from 'helpers/downloadItems'

export default ({ actions, selectors, extraStateToProps, extraDispatchToProps } = {}) => {
  if (extraStateToProps) {
    console.error('extraStateToProps in ListView container is deprecated')
  }

  return (Component) => {
    const mapStateToProps = (state, props) => ({
      ...createAuthStateToProps(state, props),
      list: selectors.selectListView(state),
      items: selectors.selectListViewItems(state),
      loading: selectors.selectListViewLoading(state),
      pageTotals: selectors.selectListViewTotals(state),
      pagination: selectors.selectListViewPagination(state),
      ...(extraStateToProps ? extraStateToProps(state, props) : {}),
    })

    const mapDispatchToProps = (dispatch, props) => ({
      getSettings: (params) => dispatch(actions.getSettings(params)),
      getItem: (itemId) => dispatch(actions.getItem(itemId)),
      getItems: (params) => dispatch(actions.getListViewItems(params)),
      createItem: (params, options) => dispatch(actions.createItem(params, options)),
      updateItem: (params, options) => dispatch(actions.updateItem(params, options)),
      updateItems: (params, options) => dispatch(actions.updateItems(params, options)),
      deleteItem: (params) => dispatch(actions.deleteItem(params)),
      deleteItems: (params, options) => dispatch(actions.deleteItems(params, options)),
      deactivateItems: (params, options) => dispatch(actions.deactivateItems(params, options)),
      downloadItems: (params) => dispatch(actions.downloadItems(params)),
      getFileTemplates: (params) => dispatch(fileTemplates.getOptions(params)),
      getFileTemplate: (fileTemplateId) => dispatch(fileTemplates.getItem(fileTemplateId)),
      getFilterTemplates: (params) => dispatch(filterTemplates.getOptions(params)),
      getFilterTemplate: (filterTemplateId) => dispatch(filterTemplates.getItem(filterTemplateId)),
      createFilterTemplate: (params) => dispatch(filterTemplates.createItem(params)),
      updateFilterTemplate: (params) => dispatch(filterTemplates.updateItem(params)),
      deleteFilterTemplate: (params) => dispatch(filterTemplates.deleteItem(params)),
      ...createDownloadItemsDispatchToProps(dispatch),
      ...(extraDispatchToProps ? extraDispatchToProps(dispatch, props) : {}),
    })

    return connect(mapStateToProps, mapDispatchToProps)(Component)
  }
}
